"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiLogin = /** @class */ (function (_super) {
    __extends(ApiLogin, _super);
    function ApiLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.LOGIN_URL = "/api/authentication/loginWidtIdAndPassword";
        _this.login = function (id, password) {
            var data = {
                id: id,
                password: password,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: {},
                url: _this.LOGIN_URL,
                method: "post",
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiLogin.getInstance = function (initValue) {
        if (!ApiLogin.classInstance) {
            this.classInstance = new ApiLogin(initValue);
        }
        return this.classInstance;
    };
    return ApiLogin;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiLogin;
